import { yupResolver as hookFormYupResolver } from '@hookform/resolvers/yup';
import type { FieldValues, Resolver } from 'react-hook-form';
import type { AnyObjectSchema } from 'yup';

const resolveWithYup = hookFormYupResolver as (
  schema: AnyObjectSchema
) => Resolver<FieldValues, unknown, FieldValues>;

/**
 * Bridges Yup 0.x schema typings with @hookform/resolvers v5, which assumes Yup 1.x ObjectSchema generics.
 */
export function yupResolver<TFieldValues extends FieldValues>(
  schema: AnyObjectSchema
): Resolver<TFieldValues, unknown, TFieldValues> {
  return resolveWithYup(schema) as Resolver<
    TFieldValues,
    unknown,
    TFieldValues
  >;
}
